import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class CompanyService {
  baseHref = `${environment.apiUrl}/company`;
  cvrApiHref = `${environment.cvrApiUrl}`;

  constructor(private http: HttpClient) {}

  getCompanyInfoFromCvrApi(cvr: string): Observable<any> {
    const url = `${this.cvrApiHref}?search=${cvr}&country=dk`;
    return this.http.get<any>(url);
  }

  createCompany(data: any): Observable<any> {
    const url = `${this.baseHref}`;
    return this.http.post<any>(url, data);
  }

  getStatusCvrAndName(): Observable<{
    status: 'pending' | 'approved' | 'rejected';
    cvr: string;
    name: string;
  }> {
    const url = `${this.baseHref}/info`;
    return this.http.get<any>(url);
  }

  deleteCompany(cvrNumber: string): Observable<any> {
    const url = `${this.baseHref}/delete/${cvrNumber}`;
    return this.http.delete<any>(url);
  }

  updateStatus(
    cvrNumber: string,
    status: 'pending' | 'approved' | 'rejected',
  ): Observable<any> {
    const url = `${this.baseHref}/update-status`;
    return this.http.put<any>(url, { cvrNumber, status });
  }

  notifyAdmin(companyId: number): Observable<any> {
    const url = `${this.baseHref}/notify`;
    return this.http.post<any>(url, { companyId });
  }

  reactivate(cvrNumber: string): Observable<any> {
    const url = `${this.baseHref}/reactivate`;
    return this.http.put<any>(url, { cvrNumber });
  }

  isActive(cvrNumber: string): Observable<{ id: number }> {
    const url = `${this.baseHref}/active/${cvrNumber}`;
    return this.http.get<any>(url);
  }

  getInactiveCompany(cvrNumber: string): Observable<{
    companyName: string;
    filename: string;
  }> {
    const url = `${this.baseHref}/inactive/${cvrNumber}`;
    return this.http.get<any>(url);
  }

  getCompanyId(cvrNumber: string): Observable<{ id: number }> {
    const url = `${this.baseHref}/id/${cvrNumber}`;
    return this.http.get<any>(url);
  }
}
